const model = {
    smallListHeader: $('.js-small-list-header'),
    filterBtn: $('.js-filter-btn'),
    appliedInTheFilter: $('.js-applied-in-the-filter')
};

$(document).on('click', '.js-branch-field', function() {
    if ($('.js-popupSmartFilter').length) {
        model.smallListHeader.addClass('smallListHeader--current');
        model.filterBtn.addClass('filterBtn--current');
        model.appliedInTheFilter.addClass('appliedInTheFilter--current');
    } 
});

$(document).on('click', '.js-applied-filter-btn', function() {
    $('.js-applied-in-the-filter-link').remove();
    model.appliedInTheFilter.removeClass('appliedInTheFilter--current');
    model.smallListHeader.removeClass('smallListHeader--current');
    model.filterBtn.removeClass('filterBtn--current');

});